import React, { useState } from "react";
import IconButton from "@shared/v2/IconButton";
import { CalendarCheckSolidV6 } from "@shared/v2/Icomoon";
import TaskModal from "./TaskModal";

const TaskFormLogAppointment = ({
  contactEmail,
  onClose,
  listingUuid,
  person,
  showModal: propsShowModal = false,
  taskable,
  user,
  v4TaskApi,
}) => {
  const [showModal, setShowModal] = useState(propsShowModal);
  return (
    <>
      {!propsShowModal && (
        <IconButton onClick={() => setShowModal(true)} aria-label="schedule appointment">
          <CalendarCheckSolidV6 />
        </IconButton>
      )}
      {showModal && (
        <TaskModal
          id="log-appointment"
          isCreatingAppointment
          onClose={() => {
            setShowModal(false);
            onClose?.();
          }}
          showTaskFor
          listingUuid={listingUuid}
          person={person}
          contactEmail={contactEmail || person.main_email}
          v4TaskApi={v4TaskApi}
          taskable={taskable}
          user={user}
        />
      )}
    </>
  );
};

export default TaskFormLogAppointment;
